import { ComponentStyleConfig } from '@chakra-ui/react'

export const Radio: ComponentStyleConfig = {
    defaultProps: {
        colorScheme: 'secondary',
    },
}
